import React from "react";

const Footer = () => {
      return (
            <div className="container py-4 mt-4" style={{ borderTop: "1px solid rgba(0, 0, 0, 0.08)" }}>
                  <div className="row">
                        <div className="col-sm-6">
                              <div className="text-center text-lg-start">
                                    <p className="copyright-text ff-heading mb-0" style={{ color: "#6d7b7e" }}>
                                          &copy; Olmo - All rights reserved
                                    </p>
                              </div>
                        </div>
                        {/* End .col-sm-6 */}

                        <div className="col-sm-6">
                              <div className="text-center text-lg-end d-flex align-items-center justify-content-lg-end gap-2 gap-lg-3" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <span><a href="/privacy" className="text-secondary">Privacy</a></span>
                                    <span className="text-secondary">•</span>
                                    <span><a href="/terms" className="text-secondary">Terms</a></span>
                              </div>
                        </div>

                        {/* End .col-sm-6 */}
                  </div>
            </div>
      );
};

export default Footer;
